import React from 'react'
import './ModuleFrame.css'
// import { Input, Icon,message} from 'antd';
import { Input } from 'antd';
import { Button } from 'antd';
import {convert_FormData_to_json2} from "../../config";
import {fetchGet} from "../utils/fetchData";
import {fetchPost} from "../utils/fetchData";
import {showErrorMsg} from "../utils/commonFunc";
// import MBItem from './MoudleItem'

const { TextArea } = Input;



class MoudleFrameWork extends React.Component {
    constructor(props) {
        super(props)
        this.searchText = '';
        this.categoryId = '';
        this.pageNo = 1;
        this.lastSelectBtn = null;
        this.state = {
            arrDataSource :[],
            arrMenu : [],
            hasMore : true,
        }
    }

    componentDidMount() {
        this.props.triggerRef(this)
    }

    cqdata = () => {
        document.getElementById('kjcqtext').value = this.searchText;
    }

    kjcqData = () => {
        let text = document.getElementById('kjcqtext').value;
        this.searchText = text;
        let formDataUpload = new FormData();
        formDataUpload.append("data", text);

        fetchPost('kjcq',convert_FormData_to_json2(formDataUpload),null)
            .then(data => {
                if (data.code === 200) {

                    console.log(data.data);
                    let r = '';
                    data.data.forEach(element => {
                        r += element + '\n';
                    });
                    document.getElementById('kjcqtext').value = r;

                }
                else {
                    showErrorMsg(data);
                }
            });
    };

    render(){
        let showExpandBtn = (this.state.arrMenu.length > 5)?'inline-block':'none';
        return(
            <div className='main_module_frame'  style={{left:this.props.visible?0+'vw':-96+'vw'}}>
                <div className='moudle_inner_div_style'>
                    <h2 style={{marginTop:10 + 'px'}}>框架提取</h2>
                    <TextArea placeholder="输入文章" id='kjcqtext' className='areaHeight' />
                    <div style={{ margin: '24px 0' }}>
                    <div style={{ float: 'left' }}>
                    <Button type="primary" onClick={this.kjcqData}>提取</Button>
                    </div>
                    <div style={{ float: 'right' }}>
                    <Button type="primary" style={{ margin_left: '10px' }} onClick={this.cqdata}>返回原文</Button>
                    </div>
                    </div>



                </div>
            </div>
        );
    }
}

export default MoudleFrameWork
